import { useSessao } from '@/lib/auth';

declare global {
  interface Window {
    octadesk?: {
      chatOptions?: {
        subDomain: string;
        showButton: string;
        openOnMessage: string;
        showFooterPoweredBy: string;
        hide: string;
      };
      chat?: {
        login: (user: { name: string; email: string }, id: string) => void;
        showApp: (id?: string) => void;
        hideApp: (id?: string) => void;
      };
    };
  }

  interface WindowEventMap {
    onOctaChatReady: CustomEvent<{ id: string }>;
  }
}

const OCTADESK_WIDGET_SELECTOR = '.octadesk-octachat-app';

let octadeskInicializado = false;

export function mostrarChatAtendimento() {
  const widget = document.querySelector<HTMLElement>(OCTADESK_WIDGET_SELECTOR);

  if (widget) {
    widget.style.display = '';
  }
}

export function esconderChatAtendimento() {
  window.octadesk?.chat?.hideApp();

  const widget = document.querySelector<HTMLElement>(OCTADESK_WIDGET_SELECTOR);

  if (widget) {
    widget.style.display = 'none';
  }
}

export function useOctadesk() {
  const { data: usuario } = useSessao();

  function abrirChat() {
    if (octadeskInicializado) {
      window.octadesk?.chat?.showApp();
      return;
    }

    const octadesk: NonNullable<Window['octadesk']> = window.octadesk ?? {};

    window.octadesk = octadesk;

    octadesk.chatOptions = {
      subDomain: 'secullum',
      showButton: 'true',
      openOnMessage: 'true',
      showFooterPoweredBy: 'true',
      hide: 'false',
    };

    window.addEventListener('onOctaChatReady', function handler(e) {
      window.removeEventListener('onOctaChatReady', handler);

      const { id } = e.detail;

      window.octadesk?.chat?.login(
        { name: usuario?.nome ?? '', email: usuario?.email ?? '' },
        id,
      );
    });

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://cdn.octadesk.com/embed.js';
    document.body.appendChild(script);

    octadeskInicializado = true;
  }

  return { abrirChat };
}
